module.exports = __webpack_public_path__ + "84451c3faccd339c72556c0246e99437.png";